import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const headerBurgerBtn = document.querySelector('[data-modal-open]');
const headerModalWindow = document.querySelector('[data-modal]');
const headerCloseBtn = document.querySelector('[data-modal-close]');
const headerModalMenu = document.querySelector('[data-modal-menu]');
const headerModalOrderBtn = document.querySelector('[data-modal-btn]');
const headerNavMenu = document.querySelector('[data-menu]');
const headerMenuList = document.querySelector('[data-menu-list]');
const headerOrderBtn = document.querySelector('[data-btn]');
const form = document.querySelector('[data-form="request"]');
const inputTel = document.querySelector('[data-tel]');

const toggleHeaderNavMenu = function () {
  try {
    if (!headerMenuList) {
      throw new Error('the menu has not been found');
    }
    headerMenuList.classList.toggle('visually-hidden');
  } catch (error) {
    console.log(error.message);
  }
};
const showHeaderModalWindow = function () {
  try {
    if (!headerModalWindow)
      throw new Error('the menu modal window has not been found');
    headerModalWindow.classList.remove('visually-hidden');
    setTimeout(() => {
      headerModalWindow.classList.add('header-modal-active');
      document.body.classList.add('no-scroll');
    }, 10);
  } catch (error) {
    console.log(error.message);
  }
};

const closeHeaderModalWindow = function () {
  try {
    if (!headerModalWindow)
      throw new Error('the menu modal window has not been found');
    headerModalWindow.classList.remove('header-modal-active');
    setTimeout(() => {
      headerModalWindow.classList.add('visually-hidden');
      document.body.classList.remove('no-scroll'); // Видаляємо клас для відновлення прокручування
    }, 10);
  } catch (error) {
    console.log(error.message);
  }
};
const moveToAnchor = function (event, isModal = true) {
  try {
    event.preventDefault();
    const targetAnchor = event.target.getAttribute('href');
    if (!targetAnchor || targetAnchor === '#') {
      return;
    }
    document.querySelector(targetAnchor).scrollIntoView({ behavior: 'smooth' });
    if (isModal) {
      closeHeaderModalWindow();
    }
  } catch (error) {
    console.log(error.message);
  }
};

headerBurgerBtn.addEventListener('click', showHeaderModalWindow);

headerCloseBtn.addEventListener('click', closeHeaderModalWindow);

headerModalMenu.addEventListener('click', moveToAnchor);

headerModalOrderBtn.addEventListener('click', moveToAnchor);

headerNavMenu.addEventListener('click', toggleHeaderNavMenu);

headerMenuList.addEventListener('click', event => {
  moveToAnchor(event, false);
  toggleHeaderNavMenu();
});

headerOrderBtn.addEventListener('click', event => {
  moveToAnchor(event, false);
});

inputTel.addEventListener('input', e => {
  e.target.value = e.target.value.replace(/[^+\d]/g, '');
});

form.addEventListener('submit', function (e) {
  e.preventDefault();

  const inputs = form.querySelectorAll('.request-input[required]');

  let isValid = true;
  const phonePattern = /^\+?\d{10,15}$/;
  const value = inputTel.value.trim();

  if (!value || !phonePattern.test(value)) {
    isValid = false;
    inputTel.classList.add('input-error');
    iziToast.warning({
      title: 'Invalid Phone',
      message:
        'Please enter a valid phone number (digits only, may start with +).',
      position: 'topRight',
    });
  } else {
    inputTel.classList.remove('input-error');
  }

  inputs.forEach(input => {
    if (!input.value.trim()) {
      isValid = false;
      input.classList.add('input-error');
    } else {
      input.classList.remove('input-error');
    }
  });

  if (!isValid) {
    iziToast.warning({
      title: 'Missing Info',
      message: 'Please fill in all required fields.',
      position: 'topRight',
    });
    return;
  }

  const formData = new FormData(form);

  fetch(form.action, {
    method: form.method,
    body: formData,
    headers: {
      Accept: 'application/json',
    },
  })
    .then(response => {
      if (response.ok) {
        iziToast.success({
          title: 'Request Sent!',
          message: 'Your request has been sent. I’ll contact you shortly.',
          position: 'topRight',
        });
        form.reset();
      } else {
        return response.json().then(data => {
          throw new Error(data.error || 'Something went wrong.');
        });
      }
    })
    .catch(error => {
      iziToast.error({
        title: 'Error',
        message: error.message,
        position: 'topRight',
      });
    });
  // form.submit();
});

// === Переключение сезонов (через data-season) ===
// const seasonButtons = document.querySelectorAll('[data-season]');
// let currentPage = window.location.pathname.split('/').pop();

// if (!currentPage || currentPage === '') {
//   currentPage = 'index.html';
// }

// seasonButtons.forEach(btn => {
//   const season = btn.dataset.season;

//   if (currentPage.includes(season)) {
//     btn.classList.add('active');
//   } else {
//     btn.classList.remove('active');
//   }
//   btn.addEventListener('click', () => {
//     seasonButtons.forEach(b => b.classList.remove('active'));
//     btn.classList.add('active');
//     window.location.href = `${season}.html`;
//   });
// });

const maskInputs = document.querySelectorAll('[data-mask="ca-postal"]');

maskInputs.forEach(input => {
  input.addEventListener('input', e => {
    let value = e.target.value
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9]/g, '');

    if (value.length > 3) {
      value = value.slice(0, 3) + ' ' + value.slice(3);
    }

    e.target.value = value;
  });
});

const swiperReviewsConfig = {
  modules: [Navigation, Pagination],
  spaceBetween: 16,
  slidesPerView: 1,
  grabCursor: true,
  pagination: {
    clickable: true,
  },
  navigation: {},
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
};

const reviewsSwiperEl = document.querySelector('[data-reviews-swiper]');
if (reviewsSwiperEl) {
  new Swiper(reviewsSwiperEl, {
    ...swiperReviewsConfig,
    pagination: {
      ...swiperReviewsConfig.pagination,
      el: reviewsSwiperEl.querySelector('.swiper-pagination'),
    },
    navigation: {
      nextEl: reviewsSwiperEl.querySelector('.swiper-button-next'),
      prevEl: reviewsSwiperEl.querySelector('.swiper-button-prev'),
    },
  });
}

const workGallerySwiperEl = document.querySelector('[data-work-gallery-swiper]');
if (workGallerySwiperEl) {
  new Swiper(workGallerySwiperEl, {
    ...swiperReviewsConfig,
    pagination: {
      ...swiperReviewsConfig.pagination,
      el: workGallerySwiperEl.querySelector('.swiper-pagination'),
    },
    navigation: {
      nextEl: workGallerySwiperEl.querySelector('.swiper-button-next'),
      prevEl: workGallerySwiperEl.querySelector('.swiper-button-prev'),
    },
  });
}

document.querySelectorAll('.faq-btn').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    const allItems = document.querySelectorAll('.faq-item');

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const controlId = button.getAttribute('aria-controls');
    const panel = controlId ? document.getElementById(controlId) : null;

    allItems.forEach(el => {
      const btn = el.querySelector('.faq-btn');
      const id = btn && btn.getAttribute('aria-controls');
      const content = id ? document.getElementById(id) : null;

      if (el !== item) {
        el.classList.remove('active');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (content) content.setAttribute('aria-hidden', 'true');
      }
    });

    item.classList.toggle('active');
    const nowExpanded = !isExpanded;
    button.setAttribute('aria-expanded', String(nowExpanded));
    if (panel) {
      panel.setAttribute('aria-hidden', String(!nowExpanded));
    }
  });
});


